import styled from 'styled-components'
import {device} from '../../../theme'

export const CommentWrap = styled.div `
    margin-top: 70px;
    @media ${device.medium}{
        margin-top: 50px;
    }
`;

export const SectionTItle = styled.div `
    margin-bottom: 47px;
`;